<template>
<div v-if="this.$store.state.profile.status == 1" class="container" id="dashboard_wrap">
	
	<div class="row mt-3 mb-3">
		<h5 v-if="viewing_user_id !== null" class="text-right col-12 gold">
			<small>Member Profile Overview:</small> <span v-text="dashboard.user_name"></span>
		</h5>
	</div>
	
	<b-card-group v-if="cards.length > 0" class="" columns>
		<div 
			v-for="card in cards" 
			:key="'card_' + card.id" :id="'card_' + card.id"
			class=""
		>
		<b-card class="m-2" :class="card.card_class">
			
			<div class="card-header">
				<div class="row small">
					<div class="col-9 text-left" @click="router_push(card.category)">
						<i v-if="card.icon" :class="card.icon" class="fa-1x pointer"></i> <span v-text="card.title"></span>
					</div>
					<div class="col-3 text-right gold">
						<small v-if="card.user_name" v-text="card.user_name"></small>
					</div>
				</div>
			</div>

			
			<div v-if="typeof card.component !== 'undefined'">
				<div v-if="card.hasChartData && card.hasChartData === 1">
					<div v-if="card.component === 'ChartLine'" class="text-center">
						<p 
							v-if="card.overview_text" v-html="card.overview_text"
							class="small text-muted text-left m-2"
						></p>
						<chart-line :chartdata="card.chartdata" />
					</div>
				</div>
				<div v-else-if="card.component === 'FeelingsLog'">
					<feelings-log />
				</div>
				<div v-else class="col-12 p-5 text-center silver">
					<p><i class="fas fa-chart-pie fa-2x"></i></p>
					<p><small>Nothing to show for the last 7 days...</small></p>
				</div>
			</div>
			
			<div v-else>
				
				<div v-if="card.loading && card.loading === 1" class="p-2 text-center gold">
					<i class="fas fa-atom fa-spin fa-2x"></i>
				</div>
				
				<div
					v-if="(card.youtube && card.youtube.length > 0) || (card.vimeo && card.vimeo.length > 0)" 
					class=""
				>
					<video-embeds :embeddata="card" classW="" show_title="0" />
				</div>
				
				
				<div v-if="card.main_text !== null" class="card-body p-2">
					<div class="text-right">
						<button class="btn btn-text btn-sm gold" @click="onClick($event, card, 'toggleMainText')">
							<i class="fas fa-chevron-up"></i>
						</button>
					</div>
					<div class="text-left" v-html="card.main_text"></div>
					<div class="text-right">
						<button class="btn btn-text btn-sm gold" @click="onClick($event, card, 'toggleMainText')">
							<i class="fas fa-chevron-up"></i>
						</button>
					</div>
				</div>
				<div v-else-if="card.description" class="card-body p-2">
					<p class="card-text p-2" v-text="card.description"></p>
					<div class="text-right">
						<button class="btn btn-text btn-sm gold" @click="onClick($event, card, 'main_text')">
							<i class="fas fa-chevron-down"></i>
						</button>
					</div>
				</div>
				
				
				<div v-if="card.list && card.list.items" class="card-body">
					<ul v-for="item in card.list.items" :key="'L_' + item.date" class="list-unstyled mb-0">
						<dl class="row small">
							<dt class="col-7"><small v-text="item.date"></small></dt>
							<dd class="col-3"><span v-text="item.mins"></span><small>min</small></dd>
						</dl>
					</ul>
				</div>
			</div>
			
			
			
			
			<div v-if="card.show_comments && card.show_comments === 1" class="card-footer" :id="'reply_' + card.id">
				<div class="row">
					<small 
						v-if="!card.reply_open || card.reply_open === 0"
						class="col gold pointer text-left"
						@click="onClick($event, card, 'replys')"
					>
						<i class="far fa-comments"></i> <span v-text="card.replies_count"></span> comments
					</small>
					<small 
						v-else
						class="col gold pointer text-left" @click="onClick($event, card, 'close_comment')">
						<i class="far fa-times-circle"></i> close comments 
					</small>
					
				</div>
	
				
			</div>
			
		</b-card>
		</div>
	</b-card-group>
	
	
	<b-modal 
		id="comments_wrapper" 
		:title="active_card.title" 
		size="xl"
	>
		<div v-if="active_card.id">	
				
			<div v-if="active_card.replies !== null" class="text-left mb-3">
				<ul class="list-group">
					<li class="list-group-item p-2" v-for="R in active_card.replies" :key="'R_' + R.id">
						<span v-text="R.title"></span> <span v-html="R.main_text"></span><br />
						<div
							v-if="(R.youtube && R.youtube.length > 0) || (R.vimeo && R.vimeo.length > 0)" 
							class="col-md-4 mb-2"
						>
							<video-embeds :embeddata="R" classW="" show_title="0" />
						</div>
				
						<div class="text-right mt-1 small">
							<b v-text="R.user_name"></b>: 
							<span v-text="R.access.date+' '+R.access.time"></span>
						</div>
					</li>
				</ul>
				
			</div>
			<div v-else class="text-muted">It's a ghost town in here... Start a conversation?</div>
					
					
			<div>
				<div>
					<p class="p-0 m-0 mt-3"><b>Post Reply</b></p>
					<b-form-textarea
						v-model="active_card.reply_text"
						placeholder="Enter something..."
						rows="3"
						max-rows="6"
						class="mt-2"
						@keyup="checkReplyForm"
					></b-form-textarea>
					
					<div class="text-right">
						<h5 v-if="error_message != ''" v-text="error_message" class="text-danger"></h5>
					</div>
				</div>
			</div>
			
    
    
		</div>
		
		
		<template #modal-footer="{ ok, cancel }">
		
			<div v-if="active_card.replys_loaded === 1">
				<button 
					type="button" class="btn btn-primary"
					@click="replyAdd()" 
					:disabled="!canSubmitReply"
				>
					Submit <i class="far fa-comment-dots"></i>
				</button>
				
				<b-button size="sm" variant="danger" @click="cancel()">
					Cancel
				</b-button>
			</div>
			<div v-else>
				Loading data...
			</div>
			
		</template>

		
	</b-modal>

</div>
</template>

<script src="//cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.1/Chart.min.js"></script>
<script src="//unpkg.com/vue-chartjs/dist/vue-chartjs.min.js"></script>

<script>
import axios from "axios";
import ChartLine from '../components/ChartLine.vue';
import VideoEmbeds from '../components/VideoEmbeds.vue';
import FeelingsLog from '../components/FeelingsLog.vue';

export default {
	name: "ProfileOverview",
	components:{ 
		ChartLine,
		FeelingsLog,
		VideoEmbeds,
	},
	props: {
		viewing_type: {
			type: String,
			default: 'user_dashboard',
		},
		viewing_user_id: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			active_card: {},
			canSubmitReply: false,
			cards: [],
			dashboard: {},
			error_message: '',
			section_title: this.$route.meta.title,
		}
	},
	computed:{
	},
	methods:{
		
		checkReplyForm(){
			if(this.active_card.reply_text === ''){
				this.canSubmitReply = false;
			} else {
				this.canSubmitReply = true;
			}
		},
		
		getCardDetails(card){
			let _this = this;
			let params = new URLSearchParams();
			params.append('token',		this.$store.state.session_id);

			if(card.forum_id){
				params.append('id',			card.forum_id);
			}
			else {
				params.append('id',			card.id);
			}
			params.append('type',		card.type);
			
			this.active_card = [];

			axios({
				url: _this.$store.state.api_url + "CardsGetDetails",
				params: params,

			}).then(function(response) {
				
				var ActiveCard = _this.cards.find(function(elm, index) {
					if(elm.id === card.id){
						return true;
					}
				});
				
				
				ActiveCard.reply_text = '';
				ActiveCard.replys_loaded = 0;
					
				if(typeof card.type === 'undefined' || card.type === null){
					console.log('card.type not set');
					
				} else if(card.type === 'single'){
					ActiveCard.main_text = response.data.post[card.id].main_text;
					ActiveCard.card_class = 'card_hightlight';
				}
				else if(card.type === 'replys'){
					if(response.data.replys !== null){
						ActiveCard.replies = Object.values(response.data.replys);
					}
					ActiveCard.replys_loaded = 1;
					
				}
				
				_this.active_card = ActiveCard;
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		getOverviewCards(){
			console.log('cardGet:' + this.viewing_type);
			let _this = this;
			let params = new URLSearchParams();
			params.append('token',		this.$store.state.session_id);
			params.append('type',		this.viewing_type);
			params.append('limit',		9);
			params.append('user_id',	this.viewing_user_id);
			
			
			this.cards = [];
			this.progress_set(.1);

			axios({
				url: _this.$store.state.api_url + "CardsProfileOverviewGet",
				params: params,

			}).then(function(response) {
				
				var tempCardA = [];
				
				_this.$store.commit("loadingNumberTotalSet", response.data.number_to_load);
				
				if(response.data.components !== null){
					let entries = Object.values(response.data.components);
					for(const item of entries){
						if(typeof item !== 'undefined'){
							tempCardA.unshift(item);
						}
					}
				}
				
				if(response.data.forum !== null){
					let entries = Object.values(response.data.forum);
					for(const item of entries){
						if(typeof item !== 'undefined'){
							tempCardA.unshift(item);
						}
					}
				}
				
				if(response.data.dashboard !== null){
					let entries = Object.values(response.data.dashboard);
					for(const item of entries){
						if(typeof item !== 'undefined'){
							tempCardA.unshift(item);
						}
					}
				}
				
				
				if(tempCardA.length > 0){
					_this.cards = tempCardA.sort(function (a, b) {
						return a.order - b.order;
					});
				}
				
				_this.progress_set(1);
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		hasActiveRoute(slug) {
			let resolved = this.$router.resolve('/'+slug)
			if(resolved.route.name != '404') {
				return true;
			}
			else {
				return false;
			}
		},
		
		load_viewing_users_details(){
			let _this = this;
			
			if(this.viewing_user_id !== null){
				console.log('load_viewing_users_details:' + this.viewing_user_id);
				_this.dasboard = {};
				let params = new URLSearchParams();
				params.append('token',		_this.$store.state.session_id);
				params.append('user_id',	_this.viewing_user_id);
				
				axios({
					url: _this.$store.state.api_url + "memberGetProfile",
					params: params,
	
				}).then(function(response) {
					
					if(response.data.profile !== null){
						console.log('add to dashboard');
						_this.dashboard = response.data.profile;
					}
					
					
				}).catch(function (error) {
					console.log(error);
				});
			}
		},
		
		onClick(e, card, type){
			e.preventDefault();
			console.log(type);
			card.loading = 1;
			
			if(type == 'replys'){
				card.type = 'replys';
				this.getCardDetails(card);
				this.$bvModal.show('comments_wrapper');
			}
			else if(type == 'main_text'){
				card.type = 'single';
				this.getCardDetails(card);
			}
			else if(type == 'toggleMainText'){
				card.main_text = null;
			}
			
			card.loading = 0;
		},
		
		progress_set(val){
			if(val < 0 || isNaN(val)) val = 0;
			this.$store.commit("loadingSet", val);
			console.log('progress_set:' + val);
		},
		
		replyAdd(){
			let _this = this;
			
			console.log('replyAdd');
			
			if(this.active_card.reply_text === null || this.active_card.reply_text === ''){
				this.error_message = 'You need to add some content to the Post Reply field!';
				this.canSubmitReply = false;
			}
			else
			{
				this.error_message = '';
				this.canSubmitReply = true;
			}
			
			if(this.canSubmitReply === true){
				let params = new URLSearchParams();
				params.append('token', _this.$store.state.session_id);
				
				if(_this.active_card.forum_id){
					params.append('post_id',	_this.active_card.forum_id);
				}
				else {
					params.append('post_id',	_this.active_card.id);
				}
			
				
				params.append('title', '');
				params.append('main_text', _this.active_card.reply_text);
	
				axios({
					method: 'post',
					url: _this.$store.state.api_url + "forum/replyAdd",
					data: params,
	
				}).then(function (response) {
					if(response.data.status == 1){
						if(typeof response.data.added_data_id !== 'undefined'){
							if(_this.active_card.replies === null){
								_this.active_card.replies = [];
							}
							_this.active_card.replies.push( response.data.added_data[response.data.added_data_id] );
							_this.active_card.reply_text = '';
						}
						_this.active_card.replies_count++;
						_this.$bvModal.hide('comments_wrapper');
					}
					else{
						_this.error_message = response.data.message;
					}
					
				}).catch(function (error) {
					console.log(error);
				});
			}
			
		},
		
		router_push(slug){
			var view_user_id = this.view_user_id ? this.view_user_id : '';
			var path = slug + '_dashboard/' + view_user_id;
			var check = this.hasActiveRoute(path);
			console.log(path);
			console.log(check);
			if(check === true){
				this.$router.push('/' + path);
			}
		},
	},
	mounted() {
		if(this.viewing_user_id !== null){
			this.load_viewing_users_details();
		}
		this.getOverviewCards();
		this.$store.commit("loadingSet", {page: .4} );
	},
	watch: {
	},
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.card-columns {
		column-count: 1;
	}
	.card-body {
		padding: 0;
	}
	@media screen and (min-width: 768px) {
		.card-columns {
			column-count: 2;
		}
	}
</style>
